module.exports = __webpack_public_path__ + "img/crew1.6d2fb6a6.jpg";